export default __webpack_public_path__ + "static/media/productivity.3bc42e04.svg";